import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.values.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import Card from '@/components/layout/Card.vue';
import { AUTH_LINK_DELETE, AUTH_LINK_LIST } from '@/store/actions/authLink';
import store from '@/store';
import AuthLinkForm from "@/views/authLink/AuthLinkForm.vue";
import AuthLinkDeleteDialog from "@/components/dialog/AuthLinkDeleteDialog.vue";
var AuthLinkTable = /*#__PURE__*/function (_Vue) {
  function AuthLinkTable() {
    var _this;
    _classCallCheck(this, AuthLinkTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthLinkTable, [].concat(args));
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "toggleAuthLinkFormDialog", false);
    _defineProperty(_this, "toggleAuthLinkDeleteDialog", false);
    _defineProperty(_this, "authLinkIdToDelete", null);
    _defineProperty(_this, "authLinkIdToUpdate", null);
    return _this;
  }
  _inherits(AuthLinkTable, _Vue);
  return _createClass(AuthLinkTable, [{
    key: "authLinks",
    get: function get() {
      return Object.values(store.getters.authLinks);
    }
  }, {
    key: "isDeleteAuthLink",
    get: function get() {
      return store.getters.isAuthLinkDeleteAivailable;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.loadAuthLink();
    }
    /**
     * Edit the current authentication link
     */
  }, {
    key: "updateAuthLink",
    value: function updateAuthLink(authLink) {
      var _this2 = this;
      this.authLinkIdToUpdate = authLink.authLinkID;
      // since 'authLinkIdToUpdate' and 'toggleAuthLinkFormDialog' are both inputs of the authLink edit modal,
      // we need to wait a tick.., to ensure authLinkIdToUpdate is well provided before we open the modal.
      setTimeout(function () {
        _this2.toggleAuthLinkFormDialog = true;
      });
    }
  }, {
    key: "loadAuthLink",
    value: function loadAuthLink() {
      var _this3 = this;
      this.loading = true;
      store.dispatch(AUTH_LINK_LIST).then(function () {
        _this3.loading = false;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorMsg = err;
      });
    }
  }, {
    key: "deleteAuthLink",
    value: function deleteAuthLink(authLink) {
      this.authLinkIdToDelete = authLink.authLinkID;
      this.toggleAuthLinkDeleteDialog = true;
    }
  }, {
    key: "confirmAuthLinkDelete",
    value: function confirmAuthLinkDelete() {
      var _this4 = this;
      this.toggleAuthLinkDeleteDialog = false;
      this.loading = true;
      store.dispatch(AUTH_LINK_DELETE, this.authLinkIdToDelete).then(function () {
        _this4.loading = false;
      }).catch(function (err) {
        _this4.loading = false;
        _this4.errorMsg = err;
      });
    }
  }]);
}(Vue);
AuthLinkTable = __decorate([Options({
  components: {
    Card: Card,
    AuthLinkForm: AuthLinkForm,
    AuthLinkDeleteDialog: AuthLinkDeleteDialog
  }
})], AuthLinkTable);
export default AuthLinkTable;